import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { Link, useNavigate } from 'react-router-dom'
import Beatloader from '../../../Common/BeatLoader';
import { getStudentMyTutorGroupListData, getStudentMyTutorOneToOneListData } from '../../../Redux/action/StudentAction';
import { getProfileData } from '../../../Redux/action/MasterAction';
import { doc, collection, getDoc, setDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firbase";
import toast from 'react-hot-toast';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';


const host = process.env.REACT_APP_API_SERVER
const StudentMySessions = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {


        dispatch(getStudentMyTutorGroupListData());
        dispatch(getStudentMyTutorOneToOneListData());

    }, []);


    const {

        loadingStudentMyTutorGroupListApi,
        StudentMyTutorGroupListApiData,
        StudentMyTutorGroupListApiError,

        loadingStudentMyTutorOneToOneListApi,
        StudentMyTutorOneToOneListApiData,
        StudentMyTutorOneToOneListApiError
    } = useSelector(state => state?.StudentReducer);



    const handleChatNavigation = async (id) => {
        try {
            const authToken = localStorage.getItem('student-token');
            const decoded = jwtDecode(authToken);
            const participant1 = decoded?.user?.id;
            const participant2 = id;


            if (!participant1 || !participant2) {
                toast.error("Invalid participant IDs. Unable to navigate to chat.");
                return;
            }

            const data = { participant1, participant2 };

            const response = await axios.post(`${host}/api/web/create-chatroom`, data, {
                headers: {
                    "x-auth-token": authToken,
                },
            });

            if (response.data?.statusCode === 200) {
                const chatroomId = response.data.data.chatroomId;
                navigate(`/student/chat/${btoa(chatroomId)}`);
            } else {
                toast.error(response.data?.message || "Failed to create chatroom!");
            }
        } catch (error) {
            console.error("Error navigating to chat:", error);
            toast.error("An error occurred while creating the chatroom. Please try again!");
        }
    };


    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Sessions
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                One To One
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                Group Courses
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingStudentMyTutorOneToOneListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row justify-content-start">
                                                    {StudentMyTutorOneToOneListApiData?.length ?
                                                        StudentMyTutorOneToOneListApiData?.map((data) => (
                                                            <div className="col-lg-6 col-md-6 mt-3" key={data?.id}>
                                                                <div className="card input-card-form bg-white">
                                                                    <div className="card-body">
                                                                        <div className="row justify-content-center">
                                                                            <div
                                                                                className="col-lg-4 col-md-4"
                                                                            // style={{ width: "fit-content" }}
                                                                            >
                                                                                <img
                                                                                    src={`${host}${data?.tutor?.profile_img}`}
                                                                                    className="img-fluid rounded-circle"
                                                                                    style={{ height: "7.6rem", width: "auto" }}
                                                                                    onError={(e) => {
                                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-8 col-md-8"
                                                                                // style={{ width: "fit-content" }}
                                                                            >
                                                                                <h5 className="mb-0 text-dark">{data?.tutor?.name}</h5>
                                                                                <p className="mb-0">{data?.tutor?.specialization}</p>
                                                                                
                                                                                {data?.tutor?.experience && <p className="mb-0">{data?.tutor?.experience} Year experience</p>}
                                                                                <div className="rating">
                                                                                    {Array.from({ length: 5 }, (_, index) => {
                                                                                        const averageRating = parseFloat(data?.tutor?.avarageRating || "0"); // Convert to number
                                                                                        if (index < Math.floor(averageRating)) {
                                                                                            return <i key={index} className="fas fa-star filled" />;
                                                                                        } else if (index < averageRating) {
                                                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                                        } else {
                                                                                            return <i key={index} className="fas fa-star" />;
                                                                                        }
                                                                                    })}
                                                                                    <span>

                                                                                        {data?.tutor?.avarageRating} <span className="text-primary">({data?.tutor?.total_rating_count} Ratings)</span>
                                                                                    </span>
                                                                                </div>
                                                                                <p className="mb-0 line-clamp-1">Course Name : {data?.course?.name}</p>
                                                                                <p className="">Course Start Date : {data?.course?.start_date}</p>
                                                                                <div className="student_coursebtns d-flex gap-3 mt-1">
                                                                                    <a onClick={() => { handleChatNavigation(data?.tutor?.id) }}
                                                                                        style={{ paddingInline: 35 }}
                                                                                        className="btn btn-primary py-1 mt-1 display-flex"

                                                                                    >
                                                                                        Chat
                                                                                    </a>
                                                                                    <Link
                                                                                        className="btn btn-outline-primary py-1 mt-1 display-flex"
                                                                                        to={`/student/one-to-one-course-details/${btoa(data?.id)}`}
                                                                                    >
                                                                                        View Details
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            {loadingStudentMyTutorGroupListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row justify-content-start">
                                                    {StudentMyTutorGroupListApiData?.length ?
                                                        StudentMyTutorGroupListApiData?.map((data) => (
                                                            <div className="col-lg-6 col-md-6 mt-3" key={data?.id}>
                                                                <div className="card input-card-form bg-white">
                                                                    <div className="card-body">
                                                                        <div className="row justify-content-center">
                                                                            <div
                                                                                className="col-lg-4 col-md-4"
                                                                            // style={{ width: "fit-content" }}
                                                                            >
                                                                                <img
                                                                                    src={`${host}${data?.tutor?.profile_img}`}
                                                                                    className="img-fluid rounded-circle"
                                                                                    style={{ height: "7.6rem", width: "auto" }}
                                                                                    onError={(e) => {
                                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                className="col-lg-8 col-md-8"
                                                                                style={{ width: "fit-content" }}
                                                                            >
                                                                                <h5 className="mb-0 text-dark">{data?.tutor?.name}</h5>
                                                                                <p className="mb-0">{data?.tutor?.specialization}</p>
                                                                                {data?.tutor?.experience && <p className="mb-0">{data?.tutor?.experience} Year experience</p>}
                                                                                <div className="rating">
                                                                                    {Array.from({ length: 5 }, (_, index) => {
                                                                                        const averageRating = parseFloat(data?.tutor?.avarageRating || "0"); // Convert rating to a number
                                                                                        const isFullStar = index < Math.floor(averageRating); // Full stars
                                                                                        const isHalfStar = index === Math.floor(averageRating) && averageRating % 1 !== 0; // Half star if it's fractional

                                                                                        if (isFullStar) {
                                                                                            return <i key={index} className="fas fa-star filled" />;
                                                                                        } else if (isHalfStar) {
                                                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                                                        } else {
                                                                                            return <i key={index} className="fas fa-star" />;
                                                                                        }
                                                                                    })}

                                                                                    <span>

                                                                                        {data?.tutor?.avarageRating} <span className="text-primary">({data?.tutor?.total_rating_count} Ratings)</span>
                                                                                    </span>
                                                                                </div>
                                                                                <p className="mb-0">Course Name : {data?.course?.name}</p>
                                                                                <p className="">Course Start Date : {data?.course?.start_date}</p>
                                                                                <div className="student_coursebtns d-flex gap-3 mt-1">
                                                                                    <a onClick={() => { handleChatNavigation(data?.tutor?.id) }}
                                                                                        style={{ paddingInline: 35 }}
                                                                                        className="btn btn-primary py-1 mt-1"

                                                                                    >
                                                                                        Chat
                                                                                    </a>
                                                                                    <Link
                                                                                        className="btn btn-outline-primary py-1 mt-1"

                                                                                        to={`/student/group-course-details/${btoa(data?.id)}`}
                                                                                    >
                                                                                        View Details
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Booking View Modal */}
                <div
                    className="modal fade"
                    id="bookingModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Booking
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <h6 className="text-primary">Start Date: 3-11-2024</h6>
                                <h6 className="text-primary">Time Slot: 14:00PM - 15PM</h6>
                                <h6 className="text-primary">Topic Details: Chapter 1</h6>
                            </div>
                            <div className="modal-footer d-flex justify-content-start">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <button type="button" className="btn btn-primary">
                                    Join Meeting
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentMySessions